import React, { useEffect } from 'react';
import '../styles/ImageGallery.css';
import { Button, IconButton } from './';
import { ChevronWide, Exit } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function ImageGallery(props) {
    const images = props.images;
    const imageIndex = props.imageIndex;
    const setImageIndex = props.setImageIndex;
    const closeImageGallery = props.closeImageGallery;
    const alt = props.alt;

    useEffect(() => {
        const toggleArrowEffect = (next) => {
            if ( next === true ) {
                if ( imageIndex === images.length - 1 ) {
                    setImageIndex(0);
                } else {
                    setImageIndex(imageIndex + 1);
                }
            } else {
                if ( imageIndex === 0 ) {
                    setImageIndex(images.length - 1);
                } else {
                    setImageIndex(imageIndex - 1);
                }
            }
        };
        
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowRight') {
                toggleArrowEffect(true);
            } else if (event.key === 'ArrowLeft') {
                toggleArrowEffect(false);
            }
            else if (event.key === 'Escape') {
                closeImageGallery();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [imageIndex, images, setImageIndex, closeImageGallery]);

    const toggleArrow = (next) => {
        if ( next === true ) {
            if ( imageIndex === images.length - 1 ) {
                setImageIndex(0);
            } else {
                setImageIndex(imageIndex + 1);
            }
        } else {
            if ( imageIndex === 0 ) {
                setImageIndex(images.length - 1);
            } else {
                setImageIndex(imageIndex - 1);
            }
        }
    };

    return (
        <div className="image-gallery-outer-container">
            <div className="image-gallery-inner-container relative-container">
                <div className="image-gallery-close-button-container">
                    <Button
                        buttonType="light-button"
                        size="large"
                        text={"Close"}
                        cta={() => closeImageGallery()}
                        disabled={false}
                        leftIcon={<Exit className="" fill={colour.gray06} size={16} clickFunc={null} />}
                        leftIconClass=""
                        rightIcon={null}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
                <span className="heading-small-regular colour-white">
                    {imageIndex + 1} / {images.length}
                </span>
                <IconButton
                    size="large"
                    icon={<ChevronWide fill={colour.gray06} className="image-gallery-arrow rotate-90" />}
                    disabled={false}
                    clickFunc={() => toggleArrow(false)}
                    standardIcon={false}
                    background={true}
                    bgType={"white"}
                    contextTooltip={false}
                    contextTooltipBG={null}
                    contextTooltipText={null}
                    customClass={"image-gallery-arrow-element image-gallery-arrow-element-left"}
                />
                <IconButton
                    size="large"
                    icon={<ChevronWide fill={colour.gray06} className="image-gallery-arrow rotate-90-negative" />}
                    disabled={false}
                    clickFunc={() => toggleArrow(true)}
                    standardIcon={false}
                    background={true}
                    bgType={"white"}
                    contextTooltip={false}
                    contextTooltipBG={null}
                    contextTooltipText={null}
                    customClass={"image-gallery-arrow-element image-gallery-arrow-element-right"}
                />
                <img
                    src={images[imageIndex]}
                    className="image-gallery-element cursor-pointer"
                    alt={alt}
                    onClick={() => toggleArrow(true)}
                />
            </div>
        </div>
    )
};

export default ImageGallery;